










































import router from "@/router/router";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { Vue, Component, Ref } from "vue-property-decorator";
import ConfirmationDialogComponent from "../common/ConfirmationDialog.vue";

@Component({
  components: {
    "confirmation-dialog": ConfirmationDialogComponent,
  },
})
export default class SystemSettingsComponent extends Vue {
  isIntiallyLoading = true;
  isLoading = false;
  isEditMode = false;

  @Ref("confirm")
  confirmationDialogComponent!: ConfirmationDialogComponent;

  get readonly() {
    return true;
  }

  get hasChanged() {
    return false;
  }

  async created() {
    this.isIntiallyLoading = true;

    this.isIntiallyLoading = false;
  }

  async onSave() {
    if (!this.isEditMode) {
      this.isEditMode = true;
      return;
    }

    if (!this.hasChanged) {
      return;
    }
  }
  async onBack() {
    if (this.isEditMode) {
      if (this.hasChanged) {
        const result = await this.confirmationDialogComponent.show({
          title: this.$t("common.confirmationDialog.cancelTitle").toString(),
          message: this.$t("common.confirmationDialog.cancelMessage").toString(),
        });

        if (result) {
          this.isEditMode = false;
          return;
        }

        return;
      }

      this.isEditMode = false;
      return;
    }

    router.back();
  }

  mounted() {
    this.setToolbarTitle();
  }

  setToolbarTitle() {
    const baseTitle = this.$t("pages.settings").toString();
    const currentPageTitle = this.$t("settings.system.dataStorage").toString();

    const toolbarTitle = baseTitle + " > " + currentPageTitle;

    ToolbarContentModule.setToolbarTitle(toolbarTitle);
  }
}
